import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./index.scss";
import AOS from "aos";

// Sections
import HeroBK from "./sections/HeroBK";
import ProblemIntro from "./sections/ProblemIntro";
import BenefitsGrid from "./sections/BenefitsGrid";
import FeaturedWork from "./sections/FeaturedWork";
import ConsistencyFeature from "./sections/ConsistencyFeature";
import BrandReadiness from "./sections/BrandReadiness";
import Plans from "./sections/Plans";
import TestimonialStrip from "./sections/TestimonialStrip";
import FAQs from "./sections/FAQs";
import ContactCTA from "./sections/ContactCTA";

export default function BrandKeeperPage() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({ duration: 900, mirror: true });
  }, []);

  // Auto-scroll to Plans when the clean pricing route loads.
  useEffect(() => {
    if (location.pathname === "/brandkeeper/pricing") {
      const target = document.getElementById("bk-plans-wrap");
      if (target) {
        const y = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location.pathname]);

  return (
    <main className="bk">
      <section id="bk-hero-wrap" className="container">
        <HeroBK />
      </section>

      <section id="bk-problem-wrap" className="container">
        <ProblemIntro />
      </section>

      <section id="bk-benefits-wrap" className="container">
        <BenefitsGrid />
      </section>

      {/* Featured Work — sits below "What BrandKeeper™ Does" */}
      <section id="bk-featured-work-wrap">
        <FeaturedWork />
      </section>

      <section id="bk-consistency-wrap" className="container">
        <ConsistencyFeature />
      </section>

      {/* Brand Readiness (SEO-friendly accordion) */}
      <section id="bk-brand-readiness-wrap" className="container">
        <BrandReadiness />
      </section>

      {/* Pricing / Plans */}
      <section id="bk-plans-wrap" className="bk-plans">
        <div className="container">
          <Plans />
        </div>
      </section>

      <section id="bk-testimonial-wrap" className="bk-testimonial">
        <TestimonialStrip />
      </section>

      <section id="bk-faqs-wrap" className="container">
        <FAQs />
      </section>

      <section id="bk-contact-cta-wrap" className="container">
        <ContactCTA />
      </section>
    </main>
  );
}